import React from "react";
import { Link } from "react-router-dom";

/**
 * Componente para mostrar el segundo nive de las News, estas se cargan a través de iteraciones 
 * tomando la información de las news desde el archivo .src/data/data.json -> "News"
 *
 * @component
 * @example
 * 
 * "News": [
    {
      "img": "img/news/01.webp",
      "imgHome": "img/news/01_home.webp",
      "text": "<b>Data Driven Marketing: personalizado, relevante y efectivo</b>",
      "shortText": "Data Driven Marketing",
      "new": true,
      "url": "/news/data-driven-marketing"
    }
  ]
 * 
 */

export const NewsHome = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 620;

  React.useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
      the "width" state variable when the window size changes */
    window.addEventListener("resize", () => setWidth(window.innerWidth));

    /* passing an empty array as the dependencies of the effect will cause this
      effect to only run when the component mounts, and not each time it updates.
      We only want the listener to be added once */
  }, []);

  const chunk = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );

  return (
    <div id="news-home" className="text-center">
      <div
        className="container-fluid padding-fluid"
        style={
          width < breakpoint
            ? { paddingLeft: "15px", paddingRight: "15px" }
            : {}
        }
      >
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>
            <span className="title">News</span>
          </h2>
        </div>
        <div className="row">
          <div
            className="col-md-12"
            style={
              width < breakpoint
                ? { paddingLeft: "0px", paddingRight: "0px" }
                : {}
            }
          >
            {props.data
              ? chunk(props.data, 3).map((e, index) => {
                  return (
                    <div
                      key={`dv0${index}`}
                      className="col-md-12"
                      style={
                        width < breakpoint
                          ? { paddingLeft: "0px", paddingRight: "0px" }
                          : {}
                      }
                    >
                      {e.map((d, i) => {
                        return (
                          <div
                            key={`dv1${i}`}
                            className="col-md-4 col-sm-6 text-center content-news"
                            style={
                              width < breakpoint
                                ? { paddingLeft: "0px", paddingRight: "0px" }
                                : {}
                            }
                          >
                            <Link to={d.url}>
                              <div key={`dv2${i}`} className="imgContainer">
                                {d.new ? (
                                  <div key={`dv3${i}`} className="newContainer">
                                    <div key={`dv4${i}`} className="new">
                                      <p>Nuevo</p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                <img
                                  className="img-responsive"
                                  key={`img${i}`}
                                  alt={d.shortText}
                                  src={d.img}
                                />
                                <div
                                  className="textNews"
                                  dangerouslySetInnerHTML={{ __html: d.text }}
                                  key={`p${i}`}
                                ></div>
                                <div
                                  className="textDescription"
                                  dangerouslySetInnerHTML={{ __html: d.description }}
                                  key={`des${i}`}
                                ></div>
                              </div>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  );
                })
              : ""}

            {/* 
            {props.data ? props.data.map((d, i) => (
                  <div key={`dv1${i}`} className="col-md-4 col-sm-6 text-center">
                      <Link to={d.url}>
                        <div key={`dv2${i}`} className="imgContainer">
                          {d.new ? 
                            <div key={`dv3${i}`} className="newContainer">
                              <div key={`dv4${i}`} className="new"><p>Nuevo</p></div>
                            </div>
                          : ''}
                            <img key={`img${i}`} alt={d.text} src={d.img} />
                            <p className="titleNews" key={`p${i}`}>{d.text}</p>
                        </div>
                      </Link>
                  </div>
                  ))
                : "loading"} */}
          </div>
        </div>
      </div>
    </div>
  );
};
